import cartContent from 'Templates/content/cart.json';

const mutations = {
  updateB2BMarketCartTotal(state, input) {
    const market = input.market.toLowerCase();
    const updatedCart = { ...state.b2bCarts.marketCarts[market] };
    updatedCart.total = input.total;
    state.b2bCarts.marketCarts = {
      ...state.b2bCarts.marketCarts,
      [market]: updatedCart
    };
  },
  addingContactItem(state, input) {
    if (!input.market) {
      return;
    }

    const market = input.market.toLowerCase();

    const key = input.id;
    const oldMarketState = state.b2bCarts.marketCarts[market];
    // console.log('addingContactItem', input, oldMarketState);

    const isEngraving = input.lineitem.attributes.find(
      (attribute) =>
        attribute.key === cartContent.lineItemsAttributes.is_engrave_product
    )
      ? 'true'
      : '';
    const isGiftBag = input.lineitem.attributes.find(
      (attribute) => attribute.key === cartContent.lineItemsAttributes.gift_bag
    )
      ? 'true'
      : '';

    const linkVariantId =
      isEngraving || isGiftBag
        ? input.lineitem.attributes.find(
            (attribute) =>
              attribute.key ===
              cartContent.lineItemsAttributes.b2b_linked_variant_id
          )
        : null;

    const productLink =
      isEngraving || isGiftBag
        ? input.lineitem.attributes.find(
            (attribute) =>
              attribute.key === cartContent.lineItemsAttributes.product_link
          )
        : null;

    const product = {
      variantId: input.variantId,
      productId: input.lineitem.merchandise.product.id,
      cartLineId: input.lineitem.id,
      quantity: input.lineitem.quantity,
      weight: input.lineitem.merchandise.weight,
      title: input.lineitem.merchandise.product.title,
      image: input.lineitem.merchandise.thumbnail?.url,
      attributes: input.lineitem.attributes,
      requires_personalisation:
        input.lineitem.merchandise.product.requires_personalisation,
      personalisation_limit:
        input.lineitem.merchandise.product.personalisation_limit,
      personalisation_product:
        input.lineitem.merchandise.product.personalisation_product,
      bottled_by_for: input.lineitem.merchandise.product.bottled_by_for,
      bottled_by_only: input.lineitem.merchandise.product.bottled_by_only,
      // The following parameters must be aligned with those listed
      // in web/wp-content/themes/global-theme/views/content/cart.json, property lineItemAttributes
      is_engrave_product: isEngraving,
      giftBag: isGiftBag,
      linkVariantId: linkVariantId?.value,
      productLink: productLink?.value
    };
    // console.log('PRODUCT', product);

    const formattedInput = {
      id: input.id,
      name: input.name,
      address: input.address,
      phone: input.phone,
      cartWeight: input.lineitem.merchandise.weight * input.lineitem.quantity,
      shippingCost: input.shippingCost,
      attributes: input.lineitem.attributes,
      products: {
        [input.lineitem.id]: product
      }
    };
    if (
      oldMarketState.contactItems[key] &&
      oldMarketState.contactItems[key].products
    ) {
      formattedInput.cartWeight =
        oldMarketState.contactItems[key].cartWeight +
        input.lineitem.merchandise.weight;
      formattedInput.shippingCost = input.shippingCost;
      formattedInput.products = {
        ...oldMarketState.contactItems[key].products,
        [input.lineitem.id]: product
      };
      // console.log('EXISTING', [
      //   oldMarketState.contactItems[key].products,
      //   formattedInput.products
      // ]);
    }

    const newContactItems = {
      ...oldMarketState?.contactItems,
      [key]: formattedInput
    };

    function formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');

      return `${year}-${month}-${day}`;
    }

    const date = new Date();
    const formattedDate = formatDate(date);

    state.b2bCarts.marketCarts[market].companyContactId =
      input.company.contactId;
    state.b2bCarts.marketCarts[market].companyId = input.company.companyId;
    state.b2bCarts.marketCarts[market].companyLocation = input.company.location;
    state.b2bCarts.marketCarts[market].companyLocationId =
      input.company.locationId;
    state.b2bCarts.marketCarts[market].cartDate = formattedDate;
    state.b2bCarts.marketCarts[
      market
    ].arbitraryCartId = Date.now().toString().slice(-6);
    state.b2bCarts.marketCarts[market].recipientsQuantity =
      Object.keys(oldMarketState.contactItems).length + 1;
    state.b2bCarts.marketCarts[market].initiated = true;
    state.b2bCarts.marketCarts[market].contactItems = newContactItems;

    function aggregateShipping() {
      let totalShippingCost = 0;

      // @todo Fix es-lint warning
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const contactKey in newContactItems) {
        totalShippingCost += newContactItems[contactKey].shippingCost;
      }

      return totalShippingCost;
    }

    state.b2bCarts.marketCarts[market].shipping = aggregateShipping();
  },
  removingContactItem(state, input) {
    const oldMarketCarts = state.b2bCarts.marketCarts;
    const cartLineIdToFind = input;
    // @todo To be fixed: use forEach and not map
    // eslint-disable-next-line array-callback-return
    Object.keys(oldMarketCarts).map((key) => {
      // @todo Variable removingProduct is never used
      // eslint-disable-next-line no-unused-vars
      let removingProduct = 0;

      const { contactItems } = oldMarketCarts[key];
      const newContactItems = {};

      Object.keys(contactItems).forEach((contactKey) => {
        const { products } = contactItems[contactKey];
        const newProducts = {};

        Object.keys(products).forEach((productKey) => {
          if (products[productKey].cartLineId === cartLineIdToFind) {
            contactItems[contactKey].cartWeight =
              contactItems[contactKey].cartWeight -
                products[productKey].weight * products[productKey].quantity ??
              0;
            return;
          }
          newProducts[productKey] = products[productKey];
        });

        if (Object.keys(newProducts).length === 0) {
          // removingContact += 1;
        } else {
          removingProduct += 1;
          newContactItems[contactKey] = {
            ...contactItems[contactKey],
            products: newProducts
          };
        }
      });

      let newShipping = 0;
      Object.keys(contactItems).forEach((contactItem) => {
        newShipping += contactItem.shippingCost;
      });

      const newContactQuantity = Object.keys(newContactItems).length;

      state.b2bCarts.marketCarts[key] = {
        ...oldMarketCarts[key],
        recipientsQuantity: newContactQuantity,
        shipping: newShipping,
        contactItems: newContactItems
      };
    });
  },
  addCartLocation(state, input) {
    if (input !== null && !state.b2bCarts.markets.includes(input)) {
      state.b2bCarts.markets = [...state.b2bCarts.markets, input];
    }
  },
  setB2bAllRecipients(state, input) {
    state.cart.marketCarts.allRecipients = input;
  },
  setB2bGlobalProducts(state, input) {
    state.b2bCarts.global.products[input.productId] = input;
  },
  appendB2bGlobalProducts(state, products) {
    // console.log('mutations/CartOps.appendB2bGlobalProducts', products);
    const key = products.productId;

    if (key === undefined) {
      return;
    }

    if (!state.b2bCarts.global.products[key]) {
      const newState = {
        ...state.b2bCarts.global.products,
        [key]: { products }
      };
      state.b2bCarts.global.products = newState;
    }
  },
  removeB2bGlobalProduct(state, input) {
    // console.log('mutations/CartOps.removeB2bGlobalProduct', input);
    const newState = { ...state.b2bCarts.global.products };
    delete newState[input];
    state.b2bCarts.global.products = newState;
  },
  removeUserProductFromGlobalCart(state, input) {
    // console.log('mutations/CartOps.removeUserProductFromGlobalCart', input);
    const key = input.productId;
    const user = input.lineItemId;

    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        global: {
          ...state.b2bCarts.global,
          products: {
            ...state.b2bCarts.global.products,
            [key]: {
              ...state.b2bCarts.global.products[key],
              recipients: {
                ...state.b2bCarts.global.products[key]?.recipients
              }
            }
          }
        }
      }
    };

    delete newState.b2bCarts.global.products[key].recipients[user];
    state.b2bCarts.global.products = newState.b2bCarts.global.products;
  },
  setMarketCartProductQuantity(state, input) {
    const market = input.market.toLowerCase();
    state.b2bCarts.marketCarts[market].productQuantity = input.productQuantity;
  },
  removingRecipientProductById(state, input) {
    const oldMarketCarts = state.b2bCarts.marketCarts;
    const cartLineIdToFind = input;
    // @todo To be fixed: use forEach and not map
    // eslint-disable-next-line array-callback-return
    Object.keys(oldMarketCarts).map((key) => {
      // @todo Variable removingProduct is never used
      // eslint-disable-next-line no-unused-vars
      let removingProduct = 0;

      const { contactItems } = oldMarketCarts[key];
      const newContactItems = {};

      Object.keys(contactItems).forEach((contactKey) => {
        const { products } = contactItems[contactKey];
        const newProducts = {};

        Object.keys(products).forEach((productKey) => {
          if (products[productKey].productId === cartLineIdToFind) {
            contactItems[contactKey].cartWeight =
              contactItems[contactKey].cartWeight -
                products[productKey].weight * products[productKey].quantity ??
              0;
            return;
          }
          newProducts[productKey] = products[productKey];
        });

        if (Object.keys(newProducts).length === 0) {
          // removingContact += 1;
        } else {
          removingProduct += 1;
          newContactItems[contactKey] = {
            ...contactItems[contactKey],
            products: newProducts
          };
        }
      });

      let newShipping = 0;
      Object.keys(contactItems).forEach((contactItem) => {
        newShipping += contactItem.shippingCost;
      });

      const newContactQuantity = Object.keys(newContactItems).length;

      state.b2bCarts.marketCarts[key] = {
        ...oldMarketCarts[key],
        recipientsQuantity: newContactQuantity,
        shipping: newShipping,
        contactItems: newContactItems
      };
    });
  },
  setAttachUserOpenInCart(state, input) {
    state.b2bCarts.global.attachUserOpenInCart = input;
  },
  setDiscountCode(state, input) {
    state.b2bCarts.global.discountCodes = [input];
  },
  removeDiscountCode(state) {
    state.b2bCarts.global.discountCodes = [];
  },
  removeRecipientFromGlobalCart(state, input) {
    const recipientId = input.companyContactId;
    const newProducts = {};

    Object.keys(state.b2bCarts.global.products).forEach((productId) => {
      const product = state.b2bCarts.global.products[productId];

      if (product && product.recipients) {
        const newRecipients = { ...product.recipients };
        delete newRecipients[recipientId];
        newProducts[productId] = {
          ...product,
          recipients: newRecipients
        };
      } else {
        newProducts[productId] = product;
      }
    });
    const newState = {
      ...state,
      b2bCarts: {
        ...state.b2bCarts,
        global: {
          ...state.b2bCarts.global,
          products: newProducts
        }
      }
    };

    state.b2bCarts = newState.b2bCarts;
  }
};

export default mutations;
